import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export const SpotifyCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        toast.error('Error al conectar con Spotify');
        navigate('/');
        return;
      }

      if (!code) {
        toast.error('Código de autorización no recibido');
        navigate('/');
        return;
      }

      try {
        // Exchange code for tokens
        const response = await axios.get(`${API}/api/spotify/callback`, {
          params: { code }
        });

        const { access_token, refresh_token, expires_at } = response.data;

        // Store tokens in localStorage
        localStorage.setItem('spotify_access_token', access_token);
        localStorage.setItem('spotify_refresh_token', refresh_token);
        localStorage.setItem('spotify_expires_at', expires_at.toString());

        toast.success('✅ Conectado con Spotify');
        
        // Redirect to home
        navigate('/');
        
        // Reload to trigger SpotifyContext
        window.location.reload();
      } catch (error) {
        console.error('Error in callback:', error);
        console.error('Error details:', error.response?.data);
        
        let errorMessage = 'Error al obtener tokens de Spotify';
        if (error.response?.data?.detail) {
          errorMessage = `Error: ${error.response.data.detail}`;
        }
        
        toast.error(errorMessage);
        navigate('/');
      }
    };

    handleCallback();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- deps: navigate and searchParams
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-500 mx-auto mb-4"></div>
        <p className="text-white text-lg">Conectando con Spotify...</p>
      </div>
    </div>
  );
};
